/* TuMundoPet · comportamiento de tienda: pestañas, menú móvil, agregar al carro por AJAX
   y aviso. Reemplaza el estado local de la maqueta por el carro real de Shopify. */
(function () {
  'use strict';

  /* ── pestañas de merchandising ─────────────────────────────────────────── */
  document.querySelectorAll('[data-tab]').forEach(function (b) {
    b.addEventListener('click', function () {
      var cont = b.closest('.contenedor');
      cont.querySelectorAll('[data-tab]').forEach(function (x) { x.classList.toggle('on', x === b); });
      cont.querySelectorAll('[data-panel]').forEach(function (p) {
        p.classList.toggle('oculto', p.dataset.panel !== b.dataset.tab);
      });
    });
  });

  /* ── aviso efímero ─────────────────────────────────────────────────────── */
  var tiempo;
  function aviso(txt) {
    var t = document.getElementById('tmp-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'tmp-toast';
      t.className = 'toast';
      document.body.appendChild(t);
    }
    t.textContent = txt;
    t.classList.add('on');
    clearTimeout(tiempo);
    tiempo = setTimeout(function () { t.classList.remove('on'); }, 2600);
  }
  window.tmpAviso = aviso;

  /* ── contador del carro ────────────────────────────────────────────────── */
  function pintarContador(n) {
    document.querySelectorAll('#ncar, #ncar2').forEach(function (e) {
      e.textContent = n;
      e.classList.toggle('oculto', !n);
    });
  }

  /* ── carro: agregar, repintar y abrir el drawer ────────────────────────
     El drawer se vuelve a pedir al servidor con ?section_id=, así que el HTML lo arma
     Liquid y no hay una segunda versión del carro escrita en JS que se pueda desincronizar. */
  function abrirDrawer() {
    var d = document.getElementById('drawer-carro');
    if (!d) return;
    d.classList.add('on');
    var v = document.querySelector('.velo');
    if (v) v.classList.add('on');
    document.body.classList.add('sin-scroll');
  }

  function aplicarHtml(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var nuevo = doc.querySelector('#drawer-carro');
    var actual = document.getElementById('drawer-carro');
    if (nuevo && actual) {
      var abierto = actual.classList.contains('on');
      actual.innerHTML = nuevo.innerHTML;
      if (abierto) actual.classList.add('on');
    }
    // la página de carro, si es la que se está viendo
    var pag = document.querySelector('.carro-pagina');
    if (pag && nuevo) {
      var cab = nuevo.querySelector('.drawer-cab');
      if (cab) cab.remove();
      pag.innerHTML = nuevo.innerHTML;
    }
  }

  function repintar() {
    return fetch('/?section_id=tmp-carro-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        aplicarHtml(html);
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (c) { pintarContador(c.item_count); return c; });
  }
  window.tmpRepintarCarro = repintar;

  function pintarContador(n) {
    document.querySelectorAll('#ncar, #ncar2').forEach(function (e) {
      e.textContent = n;
      e.classList.toggle('oculto', !n);
    });
  }

  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form[data-agregar]');
    if (!f) return;
    e.preventDefault();
    var btn = f.querySelector('button[type="submit"]');
    var txt = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Agregando…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: f.querySelector('[name="id"]').value,
                  quantity: parseInt(f.querySelector('[name="quantity"]').value || '1', 10) }],
      }),
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'error');
        return repintar();
      })
      .then(function () { abrirDrawer(); })
      .catch(function (err) { aviso(err.message || 'No se pudo agregar. Intenta de nuevo.'); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = txt; } });
  });

  /* cambiar cantidad o quitar, tanto en el drawer como en la página.
     El número se actualiza al tiro (sin esperar al servidor), los clics seguidos se juntan en
     un solo pedido, y el pedido trae el carro ya pintado: una sola ida al servidor, no tres. */
  var pendiente = {};
  var cola = Promise.resolve();

  function enviarCantidad(clave, q) {
    cola = cola.then(function () {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: clave, quantity: q, sections: 'tmp-carro-drawer' }),
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) {
            aviso(res.j.description || res.j.message || 'No se pudo actualizar el carrito.');
            return repintar();
          }
          var html = res.j.sections && res.j.sections['tmp-carro-drawer'];
          if (html) { aplicarHtml(html); pintarContador(res.j.item_count); }
          else return repintar();
        })
        .catch(function () { aviso('No se pudo actualizar el carrito.'); return repintar(); });
    });
  }

  function programar(linea, q, inmediato) {
    var clave = linea.dataset.clave;
    clearTimeout(pendiente[clave]);
    var num = linea.querySelector('.stepper-num');
    if (num && q > 0) num.value = q;
    if (q <= 0) linea.style.opacity = '.45';
    pendiente[clave] = setTimeout(function () { enviarCantidad(clave, q); }, inmediato ? 0 : 350);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cant-delta], [data-cant-quitar]');
    if (!b) return;
    e.preventDefault();
    var linea = b.closest('.linea-carro');
    if (!linea) return;
    if (b.hasAttribute('data-cant-quitar')) return programar(linea, 0, true);
    var num = linea.querySelector('.stepper-num');
    var q = Math.max(0, (parseInt(num.value, 10) || 0) + parseInt(b.dataset.cantDelta, 10));
    programar(linea, q, q === 0);
  });

  document.addEventListener('change', function (e) {
    var num = e.target.closest('.stepper-num');
    if (!num) return;
    var linea = num.closest('.linea-carro');
    var q = parseInt(num.value, 10);
    if (!linea || isNaN(q) || q < 0) { repintar(); return; }
    programar(linea, q, q === 0);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.classList && e.target.classList.contains('stepper-num')) {
      e.preventDefault();
      e.target.blur();
    }
  });

  /* abrir el drawer desde el ícono del header */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-abrir="carro"]');
    if (!b) return;
    e.preventDefault();
    abrirDrawer();
  });

  document.addEventListener('click', function (e) {
    var ab = e.target.closest('[data-abrir-aviso]');
    if (ab) {
      e.preventDefault();
      var caja = document.getElementById('aviso-stock');
      if (caja) { caja.hidden = false; ab.hidden = true; caja.querySelector('input[type=email]').focus(); }
    }
  });

  /* ── menú móvil ────────────────────────────────────────────────────────── */
  var movil = document.querySelector('.movil');
  function abrir(el) { if (el) { el.classList.add('on'); document.body.classList.add('sin-scroll'); } }
  function cerrar() {
    document.querySelectorAll('.movil.on, .tmp-drawer.on').forEach(function (x) { x.classList.remove('on'); });
    document.body.classList.remove('sin-scroll');
    var v = document.querySelector('.velo');
    if (v) v.classList.remove('on');
  }
  window.tmpCerrar = cerrar;

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-abrir="movil"]');
    if (b) { e.preventDefault(); abrir(movil); document.querySelector('.velo') && document.querySelector('.velo').classList.add('on'); }
    if (e.target.closest('[data-cerrar]') || e.target.classList.contains('velo')) cerrar();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrar(); });

  /* ── acordeón del menú móvil ───────────────────────────────────────────── */
  document.querySelectorAll('.m-item > button').forEach(function (b) {
    b.addEventListener('click', function () { b.parentNode.classList.toggle('on'); });
  });
})();

/* ── PLP: filtros, orden y acordeón ──────────────────────────────────────── */
(function () {
  'use strict';
  function ir(url) { window.location.href = url; }

  var form = document.getElementById('form-filtros');
  if (form) {
    form.addEventListener('change', function () {
      var qs = new URLSearchParams();
      form.querySelectorAll('input[type="checkbox"]:checked').forEach(function (c) { qs.append(c.name, c.value); });
      form.querySelectorAll('input[type="number"]').forEach(function (n) { if (n.value !== '') qs.set(n.name, n.value); });
      var orden = document.getElementById('orden');
      if (orden && orden.value) qs.set('sort_by', orden.value);
      ir(location.pathname + (qs.toString() ? '?' + qs.toString() : ''));
    });
  }

  var orden = document.getElementById('orden');
  if (orden) {
    orden.addEventListener('change', function () {
      var u = new URL(location.href);
      u.searchParams.set('sort_by', orden.value);
      u.searchParams.delete('page');
      ir(u.pathname + '?' + u.searchParams.toString());
    });
  }

  document.querySelectorAll('[data-plegar]').forEach(function (b) {
    b.addEventListener('click', function () { b.parentNode.classList.toggle('cerrado'); });
  });

  var bf = document.querySelector('[data-toggle-filtros]');
  if (bf) bf.addEventListener('click', function () {
    document.getElementById('filtros').classList.toggle('abierto');
  });
})();

/* ── PDP: galería, cantidad y acordeones ─────────────────────────────────── */
(function () {
  'use strict';
  var main = document.getElementById('gal-main');
  document.querySelectorAll('[data-foto]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (main) main.src = b.dataset.foto;
      document.querySelectorAll('[data-foto]').forEach(function (x) { x.classList.toggle('on', x === b); });
    });
  });

  var cant = document.getElementById('pdp-cant');
  var qty = document.getElementById('pdp-qty');
  document.querySelectorAll('[data-cant]').forEach(function (b) {
    b.addEventListener('click', function () {
      var n = Math.max(1, parseInt(cant.textContent, 10) + parseInt(b.dataset.cant, 10));
      cant.textContent = n;
      if (qty) qty.value = n;
    });
  });

  document.querySelectorAll('[data-acordeon]').forEach(function (b) {
    b.addEventListener('click', function () { b.parentNode.classList.toggle('on'); });
  });
})();

/* ── favoritos ────────────────────────────────────────────────────────────
   Shopify no trae lista de deseos. Se resuelve igual que en la maqueta: en el
   navegador. Cuando el cliente tenga cuenta, esto migra a un metafield suyo. */
(function () {
  'use strict';
  var CLAVE = 'tmp-favs-v1';
  var favs = [];
  try { favs = JSON.parse(localStorage.getItem(CLAVE) || '[]'); } catch (e) { favs = []; }

  function guardar() {
    try { localStorage.setItem(CLAVE, JSON.stringify(favs)); } catch (e) {}
    pintar();
  }

  function pintar() {
    var n = document.getElementById('nfav');
    if (n) { n.textContent = favs.length; n.classList.toggle('oculto', !favs.length); }
    document.querySelectorAll('[data-fav]').forEach(function (b) {
      b.classList.toggle('on', favs.indexOf(b.dataset.fav) >= 0);
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-fav]');
    if (!b) return;
    e.preventDefault();
    var h = b.dataset.fav, i = favs.indexOf(h);
    if (i >= 0) { favs.splice(i, 1); window.tmpAviso && window.tmpAviso('Quitado de favoritos'); }
    else { favs.push(h); window.tmpAviso && window.tmpAviso('Guardado en favoritos'); }
    guardar();
  });

  function fila(p) {
    var v = p.variants && p.variants[0];
    var img = p.featured_image || (p.images && p.images[0]);
    return '<div class="linea-carro">' +
      (img ? '<img src="' + img + '" alt="" loading="lazy" width="66" height="66">' : '') +
      '<div class="lc">' + (p.vendor ? '<span class="m">' + p.vendor + '</span>' : '') +
      '<b>' + p.title + '</b>' +
      '<a class="quitar" href="#" data-fav="' + p.handle + '">Quitar</a></div>' +
      '<div class="pr"><b class="num">' + (window.tmpCLP ? window.tmpCLP(p.price) : '') + '</b>' +
      '<a class="micro fav-ver" href="/products/' + p.handle + '">Ver</a></div></div>';
  }

  function abrirFavs() {
    var cuerpo = document.getElementById('favs-cuerpo');
    if (!cuerpo) return;
    if (!favs.length) {
      cuerpo.innerHTML = '<p class="suave" style="padding:24px 0">Todavía no guardaste nada. ' +
        'El corazón de cada producto lo agrega acá.</p>';
    } else {
      cuerpo.innerHTML = '<p class="micro suave">Cargando…</p>';
      Promise.all(favs.map(function (h) {
        return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (ps) {
        var vivos = ps.filter(Boolean);
        cuerpo.innerHTML = vivos.length ? vivos.map(fila).join('')
          : '<p class="suave" style="padding:24px 0">Los productos guardados ya no están disponibles.</p>';
      });
    }
    document.getElementById('drawer-favs').classList.add('on');
    var v = document.querySelector('.velo'); if (v) v.classList.add('on');
    document.body.classList.add('sin-scroll');
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-abrir="favs"]')) { e.preventDefault(); abrirFavs(); }
  });

  /* /cart.js y /products/x.js devuelven los montos en la unidad menor: en CLP hay que
     dividir por 100 o los precios salen ×100. */
  window.tmpCLP = function (n) {
    return '$' + new Intl.NumberFormat('es-CL').format(Math.round((n || 0) / 100));
  };

  pintar();
})();

/* ── el megamenú no debe abrirse mientras se hace scroll ──────────────────
   Con el header pegado, al bajar la página el cursor queda quieto sobre la barra y el
   navegador dispara el :hover del ítem que pasa por debajo: se abre un panel gigante
   encima del contenido sin que nadie lo haya pedido. Se bloquea el hover mientras hay
   scroll y se libera un cuarto de segundo después de que se detiene. */
(function () {
  'use strict';
  var t, raiz = document.documentElement;
  window.addEventListener('scroll', function () {
    raiz.classList.add('scrolleando');
    clearTimeout(t);
    t = setTimeout(function () { raiz.classList.remove('scrolleando'); }, 250);
  }, { passive: true });
})();

/* ── alto real del header ────────────────────────────────────────────────
   `--header-h` estaba fijo en 136 px, contando la barra utilitaria. Pero esa barra se va
   con el scroll y el header pegado mide 119: todo lo que se ancla debajo —la barra de la
   tienda, el sidebar de filtros, la galería de la ficha— quedaba flotando con un hueco.
   Se mide el alto real y se actualiza cuando cambia. */
(function () {
  'use strict';
  var header = document.querySelector('.header');
  if (!header) return;
  function medir() {
    document.documentElement.style.setProperty('--header-h', Math.round(header.getBoundingClientRect().height) + 'px');
  }
  medir();
  if (window.ResizeObserver) new ResizeObserver(medir).observe(header);
  window.addEventListener('resize', medir, { passive: true });
  window.addEventListener('load', medir);
})();

/* ── franja de lanzamiento ───────────────────────────────────────────────
   Arranca oculta y se muestra desde JS: así no parpadea en la carga para quien ya la
   cerró. Copiar el código con un clic es la mitad del asunto — nadie memoriza un cupón. */
(function () {
  'use strict';
  var faja = document.getElementById('lanzamiento');
  if (!faja) return;
  var CLAVE = 'tmp-lanzamiento-cerrada';
  var codigo = (faja.querySelector('[data-copiar]') || {}).dataset;
  var sello = CLAVE + ':' + ((codigo && codigo.copiar) || '');

  try { if (localStorage.getItem(CLAVE) === sello) return; } catch (e) {}
  faja.hidden = false;

  faja.addEventListener('click', function (e) {
    var cerrar = e.target.closest('[data-cerrar-lanzamiento]');
    if (cerrar) {
      faja.hidden = true;
      try { localStorage.setItem(CLAVE, sello); } catch (err) {}
      return;
    }
    var btn = e.target.closest('[data-copiar]');
    if (!btn) return;
    var texto = btn.dataset.copiar;
    var fallo = function () {
      var i = btn.querySelector('i');
      if (i) { i.textContent = texto; setTimeout(function () { i.textContent = 'Copiar'; }, 4000); }
    };
    var listo = function () {
      btn.classList.add('copiado');
      var i = btn.querySelector('i');
      if (i) { i.textContent = '¡Copiado!'; setTimeout(function () { i.textContent = 'Copiar'; btn.classList.remove('copiado'); }, 2400); }
    };
    /* Antes se avisaba «¡Copiado!» aunque el portapapeles fallara: en el catch no se
       hacía nada y el usuario se iba al checkout creyendo que tenía el código. Ahora
       sólo se confirma cuando de verdad se copió, y si no, se selecciona para copiar
       a mano. */
    var respaldo = function () {
      var t = document.createElement('textarea');
      t.value = texto;
      t.setAttribute('readonly', '');
      t.style.position = 'fixed';
      t.style.opacity = '0';
      document.body.appendChild(t);
      t.select();
      t.setSelectionRange(0, texto.length);
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (err) { ok = false; }
      t.remove();
      if (ok) { listo(); } else { fallo(); }
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(texto).then(listo).catch(respaldo);
    } else {
      respaldo();
    }
  });

  /* aplicar un código de descuento desde el carrito.
     Shopify no tiene API de carrito para cupones: la vía soportada es la ruta /discount/,
     que deja el código puesto en la sesión y redirige de vuelta. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-aplicar-cupon]');
    if (!b) return;
    var caja = b.closest('[data-cupon]');
    var campo = caja && caja.querySelector('input[name="codigo"]');
    var codigo = campo && campo.value.trim();
    if (!codigo) { if (campo) campo.focus(); return; }
    b.disabled = true;
    b.textContent = 'Aplicando…';
    var volver = location.pathname.indexOf('/cart') === 0 ? '/cart' : location.pathname;
    location.href = '/discount/' + encodeURIComponent(codigo) +
      '?redirect=' + encodeURIComponent(volver);
  });

})();

/* ── ventana emergente del cupón ─────────────────────────────────────────
   Aparece una vez, a los 7 s, y no en carro, pago ni cuenta: no se le tapa la compra a
   quien ya está pagando. Si la cierra no vuelve en 7 días; si aplica el código, tampoco. */
(function () {
  'use strict';
  var pop = document.getElementById('cupon-pop');
  if (!pop) return;
  if (/^\/(cart|checkouts?|account)/.test(location.pathname)) return;
  var CLAVE = 'tmp-cupon-pop';
  var DIAS = 7 * 864e5;
  try {
    var t = parseInt(localStorage.getItem(CLAVE), 10);
    if (t && Date.now() - t < DIAS) return;
  } catch (e) {}
  var previo = null;
  function cerrar() {
    pop.hidden = true;
    document.documentElement.classList.remove('cupon-pop-abierto');
    try { localStorage.setItem(CLAVE, String(Date.now())); } catch (e) {}
    if (previo && previo.focus) previo.focus();
  }
  function abrir() {
    if (document.querySelector('#drawer-carro.on')) return setTimeout(abrir, 4000);
    previo = document.activeElement;
    pop.hidden = false;
    document.documentElement.classList.add('cupon-pop-abierto');
    var b = pop.querySelector('.cupon-pop-cta'); if (b) b.focus();
  }
  setTimeout(abrir, 7000);
  pop.addEventListener('click', function (e) {
    if (e.target.closest('[data-cerrar-popup]')) return cerrar();
    if (e.target.closest('.cupon-pop-cta')) { try { localStorage.setItem(CLAVE, String(Date.now())); } catch (er) {} return; }
    var btn = e.target.closest('[data-copiar]');
    if (!btn) return;
    var i = btn.querySelector('i');
    var ok = function () { btn.classList.add('copiado'); if (i) { i.textContent = '¡Copiado!'; setTimeout(function () { i.textContent = 'Copiar'; btn.classList.remove('copiado'); }, 2400); } };
    var no = function () { if (i) { i.textContent = btn.dataset.copiar; } };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(btn.dataset.copiar).then(ok, no); else no();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) cerrar(); });
})();
